import { cva } from 'class-variance-authority';

import { RADIUS_SCALE, INTERACTIVE_STATES, COLOR_SCALE, SHADOW_SCALE } from './tokens';

const CARD_BASE_CLASSES = `border ${COLOR_SCALE.surface} ${COLOR_SCALE.foreground} transition-all ${INTERACTIVE_STATES.duration.fast} ease-in-out`;
const CARD_BASE_STYLE = { boxShadow: SHADOW_SCALE.md };

const CARD_VARIANT_STYLES = {
  surface: `${COLOR_SCALE['border-subtle']} ${COLOR_SCALE.surface}`,
  elevated: 'border-transparent',
  outline: `border-[0.5px] ${COLOR_SCALE['border-muted']} ${COLOR_SCALE.surface} shadow-none`,
  soft: `border-transparent ${COLOR_SCALE['surface-muted']} ${COLOR_SCALE.foreground} shadow-none`,
  ghost: `border-transparent bg-transparent shadow-none`,
};
const CARD_ELEVATED_STYLE = { boxShadow: SHADOW_SCALE.lg };

const _CARD_VARIANT_ALIASES = {
  default: 'surface',
  muted: 'soft',
};

const radiusVariants = {
  sm: `${RADIUS_SCALE.sm}`,
  md: `${RADIUS_SCALE.md}`,
  lg: `${RADIUS_SCALE.lg}`,
  xl: `${RADIUS_SCALE.xl}`,
  full: RADIUS_SCALE.full,
};

export const cardVariants = cva(CARD_BASE_CLASSES, {
  variants: {
    variant: {
      surface: CARD_VARIANT_STYLES.surface,
      elevated: CARD_VARIANT_STYLES.elevated,
      outline: CARD_VARIANT_STYLES.outline,
      soft: CARD_VARIANT_STYLES.soft,
      ghost: CARD_VARIANT_STYLES.ghost,
      default: CARD_VARIANT_STYLES.surface,
      muted: CARD_VARIANT_STYLES.soft,
    },
    radius: radiusVariants,
    interactive: {
      true: '',
      false: '',
    },
  },
  defaultVariants: {
    variant: 'surface',
    radius: 'lg',
    interactive: false,
  },
});

export { CARD_BASE_STYLE, CARD_ELEVATED_STYLE };
